import React from 'react';
import { styled } from 'linaria/react';
import { RowProducts } from '../ui/ProductRow/RowProducts';

const RelewareContainer = styled('section')`
  width: 100%;
  margin: 0 0 2rem 0;
`;

const Releware = ({ products, title, className }) => {
  if (products.length < 1) {
    return null;
  }
  const category = {
    name: title,
    products: {
      result: products
    }
  };
  return (
    <RelewareContainer className={className}>
      <RowProducts category={category} slider={true} title={title} />
    </RelewareContainer>
  );
};

export default Releware;
